export const Color = {
    primary: '#F15F4B',
    white: '#FFF',
    black: '#000',
    grey: '#FEFEFE',
    datatableFontColor: 'rgba(0, 0, 0, 0.6)',
    borderColor: '#CCCCCC'
}